export default __webpack_public_path__ + "static/media/rybka.596b364e.png";